
import React from 'react';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import { Calendar } from '@/components/ui/calendar';
import { isDateDisabled } from '@/utils/dateUtils';

interface DatePickerSectionProps {
  date: Date | undefined;
  setDate: (date: Date | undefined) => void;
  defaultMonth: Date;
}

const DatePickerSection: React.FC<DatePickerSectionProps> = ({ 
  date, 
  setDate, 
  defaultMonth 
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Data montażu</h3>
      
      <div className="border rounded-lg p-4 bg-white">
        <Calendar
          mode="single"
          selected={date}
          onSelect={setDate}
          disabled={isDateDisabled}
          className="pointer-events-auto"
          locale={pl}
          initialFocus
          defaultMonth={defaultMonth}
        />
      </div>
      
      <p className="text-sm text-gray-500">
        * Montaże odbywają się tylko w dni robocze
      </p>
    </div>
  );
};

export default DatePickerSection;
